<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card v-if="loginFailed">
                    <v-card-title>Login failed</v-card-title>
                    <v-card-text>
                        We weren't able to log you in. Please try again, and contact support if the problem persists.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary"
                               @click="retry"
                        >
                            Try again
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <v-progress-linear indeterminate
                                       color="primary"
                    />
                    <v-card-text>
                        Logging in...
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { $auth } from '../../services/auth';

    const MAX_LOGIN_ATTEMPTS = 2;

    export default {
        data() {
            return {
                loginFailed: false,
            };
        },
        async mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            const state = urlParams.get('state');

            const restartLogin = (reason, error) => {
                console.warn(reason, error);
                // Avoid storing the callback URL (with stale code/state) as the post-login redirect target;
                // fall back to the original pre-login URL so the user lands where they started after re-auth.
                const preservedRedirect = window.sessionStorage.getItem('auth_callback_redirect_uri') || '/';
                window.history.replaceState({}, '', preservedRedirect);

                const attempts = Number(window.sessionStorage.getItem('login_attempts') || 0) + 1;
                if (attempts >= MAX_LOGIN_ATTEMPTS) {
                    window.sessionStorage.removeItem('login_attempts');
                    this.loginFailed = true;
                    return;
                }
                window.sessionStorage.setItem('login_attempts', String(attempts));
                $auth.login();
            };

            if (!code || !state || state !== window.sessionStorage.getItem('state')) {
                restartLogin('Failed to log in: missing or mismatched state.');
                return;
            }

            try {
                await $auth.askForToken(code);
            } catch (error) {
                restartLogin('Failed to log in: token exchange failed.', error);
                return;
            }

            window.sessionStorage.removeItem('login_attempts');
            const redirectUri = window.sessionStorage.getItem('auth_callback_redirect_uri');
            window.location.href = redirectUri || '/';
        },
        methods: {
            retry() {
                window.sessionStorage.removeItem('login_attempts');
                this.loginFailed = false;
                $auth.login();
            },
        },
    };
</script>
